'use client';

import Link from 'next-intl/link';
import { usePathname } from 'next-intl/client';
export default function QueryLink({
  children = <></>,
  query,
  className = '',
}: {
  children: React.ReactNode;
  query: {};
  className?: string | void;
}) {
  const pathname = usePathname();
  return (
    <Link
      href={{
        pathname,
        query: query,
      }}
      className={className}
    >
      {children}
    </Link>
  );
}
